import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from "react-google-autocomplete";
import { setPlace } from '../../../Redux/Action/Action';
import jsonData from './jsonFilterData';
import { Modal } from "react-bootstrap";
import CuisineModalData from './CuisineModalData';
import search from '../../../assets/images/search.svg'

export default function RestaurentFilter({
    searchValue,
    setSearchValue,
    checkedFilters,
    setCheckedFilters,
    onReset,
}) {
    const place = useSelector((state) => state.place);
    const DataJson = jsonData ?? [];
    const CuisineBar = CuisineModalData ?? [];

    const [inputValue, setInputValue] = useState(searchValue);
    const [openAccordionIndex, setOpenAccordionIndex] = useState(0);
    const [cuisineModalState, setCuisineModalState] = useState(false);


    const dispatch = useDispatch()
    const localSelectedCity = localStorage.getItem('selectedCity');

    useEffect(() => {
        // find the first checked filter
        const activeLabel = Object.keys(checkedFilters).find(
            (key) => checkedFilters[key]
        );

        if (!activeLabel) return;

        // find which accordion contains this label
        const accordionIndex = DataJson.findIndex((section) =>
            section.data?.some((item) => item.label === activeLabel)
        );

        if (accordionIndex !== -1) {
            setOpenAccordionIndex(accordionIndex);
        }
    }, [checkedFilters, DataJson]);


    return (
        <>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-3">
                <div className="filter-resturante"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                    <div className="filter-header d-flex justify-content-between align-items-center">
                        <h3>Filter Restaurant</h3>
                        <button onClick={onReset} className="refresh-icon border-0"><i className="fa-solid fa-rotate-right"></i></button>
                    </div>
                    <div
                        className="search-control-wrapper input-group custom-input d-flex align-items-center gap-2 mt-3 bg-white">
                        <img src={search} alt="search" />
                        <Autocomplete
                            className="shadow-none border-0 form-control outline-0 p-0 px-2"
                            apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            placeholder={
                                localSelectedCity && localSelectedCity !== "undefined" && place
                                    ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                                    : "Where would you like to go"
                            }

                            onPlaceSelected={async (city) => {
                                const selectedCity = city.formatted_address.split(",")[0].toLowerCase();
                                // // Dispatch Redux actions
                                dispatch(setPlace(selectedCity));
                                localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                                setSearchValue(city.formatted_address.split(",")[0]);
                            }}
                        />
                    </div>
                    <div className="accordion d-flex flex-column">
                        {DataJson.map((ele, ind) => {
                            return (
                                <div className="accordion-item" key={ind}>
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button shadow-none bg-white border-0 ${openAccordionIndex === ind ? "" : "collapsed"}`}
                                            type="button"
                                            onClick={() =>
                                                setOpenAccordionIndex((prev) => (prev === ind ? null : ind))
                                            }
                                        >
                                            {ele?.heading}
                                        </button>
                                    </h2>

                                    <div
                                        className={`accordion-collapse collapse ${openAccordionIndex === ind ? "show" : ""}`}
                                    >
                                        <div className="accordion-body pt-0">
                                            <ul className="custom-list">
                                                {ele?.data
                                                    ?.filter((data) => data?.label) // ✅ remove empty labels
                                                    .map((data, index) => (
                                                        <li key={index}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={!!checkedFilters[data.label]}
                                                                onChange={(e) => {
                                                                    const isChecked = e.target.checked;

                                                                    setCheckedFilters(
                                                                        isChecked
                                                                            ? { [data.label]: true } // ✅ only one allowed
                                                                            : {}                     // optional: allow uncheck
                                                                    );

                                                                    if (isChecked) {
                                                                        setOpenAccordionIndex(ind);
                                                                    }
                                                                }}
                                                            />
                                                            <span>{data?.label}</span>
                                                        </li>
                                                    ))}

                                                {ele?.heading === "CUISINE" && (
                                                    <li className="view-more-item">
                                                        <button
                                                            type="button"
                                                            className="view-more-btn"
                                                            onClick={() => setCuisineModalState(true)}
                                                        >
                                                            View more
                                                        </button>
                                                    </li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className="book-trip-btn">
                        <button className="view-all-btn w-100 justify-content-center gap-2 mt-3" onClick={onReset}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M0.666992 7.66669C0.666992 9.05116 1.07754 10.4045 1.8467 11.5557C2.61587 12.7068 3.70912 13.604 4.98821 14.1338C6.26729 14.6637 7.67476 14.8023 9.03262 14.5322C10.3905 14.2621 11.6378 13.5954 12.6167 12.6164C13.5957 11.6375 14.2624 10.3902 14.5325 9.03232C14.8026 7.67445 14.664 6.26698 14.1341 4.9879C13.6043 3.70882 12.7071 2.61557 11.556 1.8464C10.4048 1.07723 9.05146 0.666687 7.66699 0.666687C5.71006 0.674049 3.83175 1.43764 2.42477 2.7978L0.666992 4.55557M0.666992 4.55557V0.666687M0.666992 4.55557H4.55588"
                                    stroke="white" strokeWidth="1.33333" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                            Restart
                        </button>
                    </div>
                </div>
            </div>

            <Modal
                show={cuisineModalState}
                onHide={() => setCuisineModalState(false)}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Cuisine</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row">
                        {CuisineBar.map((ele, index) => (
                            <div className="col-6 mb-2" key={index}>
                                <label className="d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        checked={!!checkedFilters[ele.type]}
                                        onChange={(e) => {
                                            const isChecked = e.target.checked;

                                            setCheckedFilters(
                                                isChecked
                                                    ? { [ele.type]: true }
                                                    : {}
                                            );

                                            if (isChecked) {
                                                setOpenAccordionIndex(
                                                    DataJson.findIndex((d) => d.heading === "CUISINE")
                                                );
                                            }
                                        }}

                                    />
                                    {ele.type}
                                </label>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>

        </>
    )
}
